/**
 * The summary card of a skipped opening (docs/design/C0_OPENING_PLAINS.md §5: hold a key to skip, then a 3-line card):
 * the lines are data (`OPENING_RECAP`, data/plainsOpening.ts). It shows over the wake-up for a few seconds, or
 * until a click; it changes nothing in the world.
 */
import './sceneRecap.css';
import { OPENING_RECAP } from '@nine/shared';
import { h } from './dom';

/** Seconds the card stays before it fades. */
const SHOW_FOR = 8;

let card: HTMLDivElement | null = null;
let timer = 0;

export function showRecap(): void {
  if (document.body.classList.contains('duel-on')) return; // never over a bout
  card?.remove();
  window.clearTimeout(timer);
  const el = h('div', { id: 'sceneRecap', role: 'note' }, h('h3', {}, 'เรื่องที่ผ่านมา'), ...OPENING_RECAP.map((t) => h('p', {}, t)), h('small', { class: 'recap-hint' }, 'กด Space / Esc หรือคลิกเพื่อปิด'));
  const off = () => {
    window.removeEventListener('keydown', onKey, true);
    window.removeEventListener('pointerdown', onAny, true);
  };
  const close = () => {
    off();
    el.classList.add('out');
    window.setTimeout(() => el.remove(), 650);
    if (card === el) card = null;
  };
  // Space, Esc, Enter or any click (also on a window opened over it) closes the card; it never stays over panels.
  const onKey = (e: KeyboardEvent) => {
    if (!e.repeat && (e.key === ' ' || e.key === 'Escape' || e.key === 'Enter')) close();
  };
  const onAny = () => close();
  window.addEventListener('keydown', onKey, true);
  window.addEventListener('pointerdown', onAny, true);
  document.body.append(el);
  card = el;
  timer = window.setTimeout(close, SHOW_FOR * 1000);
}
